export default (item, cssClass = 'active') => {
  const { previousElementSibling } = item
  if (previousElementSibling === null) {
    return
  }
  item.addEventListener('click', () => {
    previousElementSibling.classList.add(cssClass)
  })
}
